// Report di esempio — basato su un'analisi REALE (anonimizzata) di una bolletta luce
// Schema identico all'output AI: verdetto_immediato, rischi_principali, clausole_pericolose, ecc.

export const mockReportBasic = {
  categoria: "Energia (luce/gas)",
  file_name: "Bolletta-Luce-Esempio.pdf",
  contract_name: "Bolletta-Luce-Esempio.pdf",
  report_type: "basic",

  verdetto_immediato: {
    giudizio: "Migliorabile",
    spiegazione: "Il costo per kWh è superiore alla media ARERA e ci sono costi accessori poco trasparenti. Prima di rinnovare, vale la pena confrontare altre offerte."
  },

  rischi_principali: [
    "Costo per kWh di €0,183 superiore alla media ARERA di €0,10-0,13 (Pagina 1, Quadro Sintetico)",
    "Interessi di mora elevati in caso di ritardo nel pagamento (Pagina 4, Interessi moratori)",
    "Rinnovo tariffa alla scadenza senza indicazioni chiare sulle nuove condizioni (Pagina 2, Opzione Tariffaria)",
    "Costi di trasporto e gestione contatore non dettagliati (Pagina 1, Quadro Sintetico)",
    "Possibile sospensione della fornitura per mancato pagamento (Pagina 4)"
  ],

  clausole_pericolose: [
    {
      titolo: "Interessi di mora elevati",
      dove: "Pagina 4, Interessi moratori e ritardato pagamento",
      cosa_fa: "Addebita interessi di mora al tasso BCE + 3,5% per ogni ritardo di pagamento.",
      impatto: "Costi aggiuntivi significativi anche per pochi giorni di ritardo sulla bolletta."
    },
    {
      titolo: "Rinnovo tariffa senza condizioni chiare",
      dove: "Pagina 2, Opzione Tariffaria",
      cosa_fa: "Alla scadenza dell'offerta la tariffa viene rinnovata, ma il contratto non specifica le nuove condizioni economiche.",
      impatto: "Rischi di ritrovarti un prezzo per kWh più alto senza accorgertene."
    }
  ],

  costi_nascosti: [
    "Spesa per trasporto e gestione contatore di €10,52 non dettagliata (Pagina 1, Quadro Sintetico)",
    "Canone TV di €9,00 addebitato in bolletta (Pagina 1, Quadro Sintetico)"
  ],

  cosa_fare: {
    azione: "Chiedi modifiche",
    perche: "Il costo per kWh è sopra la media di mercato e le spese accessorie non sono trasparenti. Contatta il fornitore o confronta altre offerte sul Portale Offerte ARERA prima del rinnovo."
  },

  spiegazione_semplice: "Questa bolletta è più costosa della media: paghi l'energia €0,183 al kWh quando la media ARERA è €0,10-0,13. Inoltre ci sono costi accessori (trasporto, gestione contatore) poco chiari e, se paghi in ritardo, gli interessi sono alti. Non è una truffa, ma puoi risparmiare: confronta altre offerte o chiedi condizioni migliori prima del rinnovo."
};

export const mockReportPremium = {
  ...mockReportBasic,
  report_type: "premium",

  livello_rischio: {
    globale: "Medio",
    finanziario: "Medio",
    vincolatività: "Basso",
    spiegazione: "Il costo elevato e gli interessi di mora rappresentano un rischio finanziario concreto, ma la vincolatività è bassa: puoi cambiare fornitore senza penali."
  },

  simulazione_pratica: {
    recesso: "Puoi cambiare fornitore in qualsiasi momento senza penali: nel mercato libero dell'energia il recesso è gratuito con preavviso di circa 3 settimane.",
    ritardo_pagamento: "Interessi di mora al tasso BCE + 3,5% dal primo giorno di ritardo e, dopo i solleciti, possibile sospensione della fornitura.",
    cambio_condizioni: "Il fornitore può modificare le condizioni alla scadenza dell'offerta: deve avvisarti con preavviso, controlla sempre le comunicazioni in bolletta.",
    reclamo: "Se non ricevi risposta soddisfacente a un reclamo scritto, puoi attivare gratuitamente il Servizio Conciliazione ARERA online (Pagina 6)."
  },

  scenari_peggiori: [
    "Paghi in ritardo più bollette: gli interessi di mora si accumulano e rischi la sospensione della fornitura con costi di riattivazione.",
    "Non leggi la comunicazione di rinnovo: la tariffa viene rinnovata a condizioni peggiorative e paghi di più per mesi senza accorgertene.",
    "I costi accessori non dettagliati aumentano nel tempo senza che tu possa verificarne la correttezza."
  ],

  consiglio_strategico: "Contatta il fornitore per chiedere una tariffa in linea con la media ARERA (€0,10-0,13/kWh). Se non ottieni condizioni migliori, usa il Portale Offerte ARERA (ilportaleofferte.it) per confrontare offerte certificate: con i tuoi consumi attuali potresti risparmiare €150-250 all'anno. Imposta un promemoria prima della scadenza dell'offerta per non subire il rinnovo automatico."
};
